module.exports = __webpack_public_path__ + "static/media/BreakingBarriersMVP.e8550b74.jpg";